import React, { useMemo, useState } from "react";
import "./ebook-forms.css";
import { ebookSubmission } from "../Transformations/FormData";
import { Alert, Box, Button, Modal, Typography } from "@mui/material";

export default function EbookForms({ type }) {
	const [ebookInfo, SetEbookInfo] = useState(0);
	const [open, setOpen] = useState(false);
	const toggleModal = () => setOpen(!open);
	const style = useMemo(
		() => ({
			position: "absolute",
			boxShadow:
				"0.2rem 0.2rem 0.2rem #edf7ed, 0.2rem -0.2rem 0.2rem #edf7ed, -0.2rem 0.2rem 0.2rem #edf7ed, -0.2rem -0.2rem 0.2rem #edf7ed",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			width: 400,
			bgcolor: "background.paper",
		}),
		[]
	);
	const handleSubmit = async (event) => {
		event.preventDefault();
		const formData = new FormData(event.target);
		const formDataObject = Object.fromEntries(formData);
		// console.log("form", formDataObject);
		const emailStatus = await ebookSubmission(formDataObject);

		if (emailStatus.status === "mail_sent") {
			toggleModal();
		}

		// Reset the form after submission
		event.target.reset();

		const linkToNavigate =
			ebookInfo == 1
				? "https://feingeist-beratung.de/wp-content/uploads/2023/12/EBook_Ihr_Weg_zur_digitalen_Hausverwaltung.pdf"
				: "https://feingeist-beratung.de/wp-content/uploads/2024/03/Whitepaper_ESG-fur-die-Immobilienwirtschaft.pdf";

		window.location.href = linkToNavigate;
	};

	return (
		<div className="main-fields ebook-section-page">
			<div className="ebook-page-container">
				{type == "ebook" ? (
					<div className="fokusthema-form">
						<div className="field-hd">
							<h2>EBook</h2>
						</div>
						<div
							className={
								ebookInfo == 1 ? "ebook-page ebbok-info-show" : " ebook-page"
							}
						>
							<div className="ebook-field popout-container">
								<div className="ebook-illustration popout-item">
									<img
										title="Ebook"
										alt="Ebook"
										className="ebook-image"
										src="https://feingeist-beratung.de/wp-content/uploads/2024/02/ebook_illustration.png"
									/>
								</div>

								<div className="ebook-container">
									<h3 className="ebook-hd">
										Ihr Weg zur digitalen Hausverwaltung
									</h3>

									<p className="ebook-home">
										Laden Sie jetzt Ihr kostenloses EBook zur Digitalisierung
										Ihrer Hausverwaltung herunter, damit die Transformation
										erfolgreich starten kann.
									</p>
									<p>
										<a
											className="download-button"
											id="ebook-download-button"
											onClick={(e) => SetEbookInfo(1)}
										>
											kostenlos herunterladen!
										</a>
									</p>
								</div>
							</div>

							<div className="ebook-info">
								<div className="form">
									<h2>Ihr Weg zur digitalen Hausverwaltung</h2>

									<form
										name="newsletter-ebook-form"
										onSubmit={handleSubmit}
										id="ebook-form"
										className=" "
									>
										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">Name (optional)</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="name"
														type="text"
														className=" "
														placeholder="Ihr Name"
														autoComplete="on"
													/>
												</div>
											</div>
										</div>

										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">
													Telefonnummer (beste Erreichbarkeit, optional)
												</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="phone"
														type="text"
														className=" "
														placeholder="Ihre Telefonnummer"
													/>
												</div>
											</div>
										</div>

										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">Email (optional)</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="email"
														type="email"
														className=" "
														placeholder="Ihre Email-Adresse"
													/>
												</div>
											</div>
										</div>

										<button
											aria-label="download-btn"
											className="download-button"
											id="ebook-download-button"
											type="submit"
										>
											Ebook herunterladen
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="fokusthema-form">
						<div className="field-hd">
							<h2>ESG-Whitepaper</h2>
						</div>
						<div
							className={
								ebookInfo == 2 ? "ebook-page ebbok-info-show" : " ebook-page"
							}
						>
							<div className="ebook-field popout-container">
								<div className="ebook-illustration popout-item esg_tree_image">
									<img
										title="Ebook"
										alt="Ebook"
										className="ebook-image"
										src="https://feingeist-beratung.de/wp-content/uploads/2024/03/esg-ebook.png"
									/>
								</div>

								<div className="ebook-container">
									<h3 className="ebook-hd">ESG für die Immobilienwirtschaft</h3>

									<p className="ebook-home">
										Laden Sie jetzt Ihr kostenloses ESG-Whitepaper herunter, um
										zu erfahren, wie Immobilienbestandhalter und Verwalter ESG
										als Chance nutzen sollten
									</p>
									<p>
										<a
											className="download-button"
											id="ebook-download-button"
											onClick={(e) => SetEbookInfo(2)}
										>
											kostenlos herunterladen!
										</a>
									</p>
								</div>
							</div>

							<div className="ebook-info">
								<div className="form">
									<h2>ESG-Whitepaper</h2>

									<form
										name="newsletter-ebook-form"
										onSubmit={handleSubmit}
										id="ebook-form"
										className=" "
									>
										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">Name (optional)</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="name"
														type="text"
														className=" "
														placeholder="Ihr Name"
														autoComplete="on"
													/>
												</div>
											</div>
										</div>

										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">
													Telefonnummer (beste Erreichbarkeit, optional)
												</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="phone"
														type="text"
														className=" "
														placeholder="Ihre Telefonnummer"
													/>
												</div>
											</div>
										</div>

										<div className="form-field  ">
											<div className="form-label">
												<label className="inline">Email (optional)</label>
											</div>
											<div className="form-data">
												<div className="form-input-wrapper ">
													<input
														name="email"
														type="email"
														className=" "
														placeholder="Ihre Email-Adresse"
													/>
												</div>
											</div>
										</div>

										<button
											aria-label="download-btn"
											className="download-button"
											id="ebook-download-button"
											type="submit"
										>
											Ebook herunterladen
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
			<Modal open={open} onClose={toggleModal}>
				<Box sx={style}>
					<Typography variant="h6">
						<Alert severity="success">
							<p className="text-center">
								Ihr Download steht bereit! Viel Vergnügen beim Lesen.
							</p>
						</Alert>
					</Typography>
				</Box>
			</Modal>
		</div>
	);
}
